import React from 'react'
import { DatePicker, DatePickerProps, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { Dayjs } from 'dayjs'
import { useTranslation } from 'react-i18next'
import { TextField, TextFieldProps } from '@mui/material'

// we use any here because we canot know in advance if components will use Native Date or dayjs
const DatePickerWrapper = (props: DatePickerProps<unknown, any>) => {
    const { i18n: { language } } = useTranslation();

    // TODO: add correct type
    const localeMap: any = {
        en: { name: '', format: "DD/MM/YYYY", placeholder: "dd/mm/yyyy" },
        nl: { name: '', format: "DD/MM/YYYY", placeholder: "dd/mm/jjjj" },
        fr: { name: '', format: "DD/MM/YYYY", placeholder: "dd/mm/jjjj" },
    };

    React.useEffect(() => {
        // console.log('props', props)
        // console.log('render', props.renderInput({}))
    })

    // we initialize here the correct date types
    const DatePickerProps: DatePickerProps<typeof props.value, typeof props.value> = {
        ...props,
        inputFormat: localeMap[language].format,
        renderInput: (params: TextFieldProps) => (
            <TextField
                {...params}
                {...props.renderInput(params).props}
                inputProps={{
                    ...params.inputProps,
                    placeholder: localeMap[language].placeholder
                }}
            />
        )
    }

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={language}
        >
            <DatePicker {...DatePickerProps} />
        </LocalizationProvider>
    )
}

export default DatePickerWrapper;
